module.exports = __webpack_public_path__ + "f7828779721d740c55cbcae70b973641.pdf";